import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import setImporter from '../../actions/importers/setImporter'
import updateImporter from '../../actions/importers/updateImporter'
import awaitAccessToken from '../../modules/awaitAccessToken'
import actionTypes from '../../action-types'

const onUpdateImporter = function* onUpdateImporter() {
  yield takeLatest(actionTypes.IMPORTERS.UPDATE, function* onUpdateImporterSaga(action) {
    const { payload: { id, ...data } } = action
    const accessToken = yield call(awaitAccessToken)

    let response
    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.importers}/${id}`,
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
        data,
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reUpdateImporter() {
          yield put(updateImporter(action.payload))
        })
      }

      rejectAction(action, e.response.data.errors || 'An unknown error occurred')

      return
    }

    if (!response || !response.data) {
      return
    }

    if (response.status !== 204) {
      yield put(setImporter(response.data.data))
    }

    acceptAction(action, response.data.data)
  })
}

export default onUpdateImporter
